import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VCard,
  VForm,
  VTextField,
  VDialog,
  VProgressCircular,
  VTooltip,
  VSelect,
  VTextarea,
  transitions,
  VSnackbar,
  VList
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VCard,
    VForm,
    VTextField,
    VDialog,
    VProgressCircular,
    VTooltip,
    VSelect,
    VTextarea,
    transitions,
    VSnackbar,
    VList
  },
  theme: {
    headerBar: '#5b6576',
    background: '#f0f4fa'
  }
})
